import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PROMOTION_CONSTRAINTS } from './constraints.js';
import { promotionAccountPctSchema } from './promotion-account-pct-schema.js';
import { promotionBrandPctSchema } from './promotion-brand-pct-schema.js';
import { promotionCategoryIdsSchema } from './promotion-category-ids-schema.js';
import { promotionNameSchema } from './promotion-name-schema.js';
import { promotionTypeSchema } from './promotion-type-schema.js';
import { checkPromotionTypeRequirements } from './rules.js';
export const createPromotionInputSchema = z
    .object({
    // WHY: the membership check compares this id as a string with Postgres's lowercase ids.
    brandId: requiredUuidString(`${PROMOTION_CONSTRAINTS.brand.label} is required`, 'Invalid brand selection.').transform((value) => value.toLowerCase()),
    name: promotionNameSchema,
    type: promotionTypeSchema,
    brandPct: promotionBrandPctSchema,
    accountPct: promotionAccountPctSchema,
    categoryIds: promotionCategoryIdsSchema,
    requiresApproval: z.boolean().optional().nullable(),
})
    .superRefine((input, context) => {
    for (const issue of checkPromotionTypeRequirements(input)) {
        context.addIssue({ code: 'custom', message: issue.message, path: issue.path });
    }
});
//# sourceMappingURL=create-input.js.map